import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ArrowDownCircle = ({ className }) => {
  return (
    <svg
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-arrow-down-circle', { [className]: className })}
    >
      <path
        d='M9.64645 15.3536C9.84171 15.5488 10.1583 15.5488 10.3536 15.3536L13.5355 12.1716C13.7308 11.9763 13.7308 11.6597 13.5355 11.4645C13.3403 11.2692 13.0237 11.2692 12.8284 11.4645L10 14.2929L7.17157 11.4645C6.97631 11.2692 6.65973 11.2692 6.46447 11.4645C6.2692 11.6597 6.2692 11.9763 6.46447 12.1716L9.64645 15.3536ZM9.5 -2.18557e-08L9.5 15L10.5 15L10.5 2.18557e-08L9.5 -2.18557e-08Z'
        fill='currentColor'
      />
      <circle cx='10' cy='10' r='9.5' transform='rotate(90 10 10)' stroke='currentColor' />
    </svg>
  );
};

ArrowDownCircle.propTypes = {
  className: PropTypes.string,
};

export default ArrowDownCircle;
